/** @internal */
export const OP_FAIL = "Fail";
/** @internal */
export const OP_DIE = "Die";
/** @internal */
export const OP_INTERRUPT = "Interrupt";
/** @internal */
export const OP_SUCCEED = "Succeed";
/** @internal */
export const OP_RETRY = "Retry";
//# sourceMappingURL=tExit.js.map